// import { Component, OnInit } from '@angular/core';
// import { Observable, ReplaySubject } from 'rxjs';
// import { ContractDto } from 'src/app/models/contractDto';
// import { NotificationType } from 'src/app/models/notification.message';
// import { ContractsService } from 'src/app/services/contracts.service';
// import { FileUploadService } from 'src/app/services/file-upload.service';
// import { NotificationService } from 'src/app/services/notification.service';
// import { NzTableModule } from 'ng-zorro-antd/table';
// import * as XLSX from 'xlsx';
// import { EmployeeUploadInfo } from 'src/app/models/employee-upload-info';
// import { contractorType } from 'src/app/models/ContractorType';

// @Component({
//   selector: 'app-file-upload',
//   templateUrl: './file-upload.component.html',
//   styleUrls: ['./file-upload.component.css']
// })
// export class FileUploadComponent implements OnInit {

//   uploadDisabled: boolean = true;
//   employeeFile: File | any;
//   Contracts: ContractDto[] = [];
//   contract: any;
//   uploadedfiles: EmployeeUploadInfo[] = [];
//   showPendingError: boolean = false;
//   counter:number=0;
//   arrayBuffer: any;
//   fileDetailData: [] | any;

//   formMode: 'multiple' | 'single' = 'multiple'; // Default to multiple

// singleEmployee: any = {
//   contractId: 0,
//   firstName: '',
//   lastName: '',
//   email: '',
//   phoneNumber: '',
//   gender: '',
//   labourRate: 0,
//   age: 0,
//   address: '',
//   qualification: '',
//   position: '',
//   desciption: '',
//   lastPlaceOfWork: '',
//   nextOfKin: '',
//   nextOfKinPhone: '',
//   nextOfKinAddress: '',
//   requestNumber: '',
//   workLocation: '',
//   axiom: '',
//   startDate: '',
//   endDate: '',
//   headCountClassification: '',
//   modeOfHeadCount: ''
// };

//   constructor(private fileUploadService: FileUploadService, private notification: NotificationService,
//     private contractsService: ContractsService) { }

//   ngOnInit(): void { this.LoadDropDowns(); }

//   async LoadDropDowns() {


//     let resContracts = await this.contractsService.getContractsValidforEmpcreation().toPromise();
//     this.Contracts = <ContractDto[]>resContracts.responseData;

//   }
//   async onContractChange(e: any) {
//     var id = this.contract.id;

//     console.log(e);
//     let resContracts = await this.fileUploadService.GetByRequest(id).toPromise();
//     this.uploadedfiles = <EmployeeUploadInfo[]>resContracts.responseData;
//     let result = this.uploadedfiles.find(i => i.uploadedFileStatus === "New");
//     if (result) { this.showPendingError = true; }
//     else
//       this.showPendingError = false;
//       this.fileDetailData=null;
//   }
//   onChange(event: any) {
//     this.employeeFile = event.target.files[0];

//     if (!(this.employeeFile === undefined)) {

//       if (this.employeeFile.name.endsWith('.xlsx')) {

//         let fileReader = new FileReader();
//         fileReader.readAsArrayBuffer(this.employeeFile);
//         fileReader.onload = (e) => {
//           this.arrayBuffer = fileReader.result;
//           var data = new Uint8Array(this.arrayBuffer);
//           var arr = new Array();
//           for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
//           var bstr = arr.join("");
//           var workbook = XLSX.read(bstr, { type: "binary" });
//           var first_sheet_name = workbook.SheetNames[0];
//           var worksheet = workbook.Sheets[first_sheet_name];
//           this.fileDetailData = XLSX.utils.sheet_to_json(worksheet, { raw: true });
//           this.counter= this.fileDetailData.length;

//           this.uploadDisabled = false;
//         }
//       }
//       else { this.uploadDisabled = true; this.fileDetailData = null }
//     }
//     else { this.uploadDisabled = true; this.fileDetailData = null }
//   }


//   onUpload() {

//     const reader = new FileReader();
//     let base64String;
//     const that = this;

//     reader.onload = (file => {
//       return function (e: any) {
//         var binaryData = e.target.result;

//         base64String = btoa(binaryData);

//         const data = {
//           stringContent: base64String,
//           fileName: file.name.split('.')[0],
//           filePath: file.name,
//           contractId: that.contract.id
//         };

//         
//         var fileCount = that.fileDetailData.length;
//         var numberActive = that.contract.numberofActiveEmployees;
//         var numberAllowed = that.contract.noOfStaff;

//         if ((fileCount + numberActive) > numberAllowed) {
//           that.notification.sendMessage({
//             message: 'Please ensure uploaded file is within approved number of staff',
//             type: NotificationType.error
//           });
//           return;
//         }
//         that.fileUploadService.upload(data).subscribe({
//           next: (data => {
//             if (data.responseCode == "00") {

//               that.notification.sendMessage({
//                 message: data.message,
//                 type: NotificationType.success
//               });

//             }
//             else {

//               that.notification.sendMessage({
//                 message: data.message,
//                 type: NotificationType.error
//               });

//             }

//           }),
//           error: ((error: any) => {
//             console.log(error.error);
//             that.notification.sendMessage({
//               message: error.error.message,
//               type: NotificationType.error
//             });
//           })
//         });
//       };
//     })(that.employeeFile);

//     reader.readAsBinaryString(that.employeeFile);
//   }
// }

import { Component, OnInit } from '@angular/core';
import { ContractDto } from 'src/app/models/contractDto';
import { NotificationType } from 'src/app/models/notification.message';
import { ContractsService } from 'src/app/services/contracts.service';
import { FileUploadService } from 'src/app/services/file-upload.service';
import { NotificationService } from 'src/app/services/notification.service';
import * as XLSX from 'xlsx';
import { EmployeeUploadInfo } from 'src/app/models/employee-upload-info';
import { AxiomsService } from 'src/app/services/axiom.service';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.css']
})
export class FileUploadComponent implements OnInit {
  uploadDisabled: boolean = true;
  employeeFile: File | any;
  Contracts: ContractDto[] = [];
  contract: any;
  id: any;
  type: string = '';
  uploadedfiles: EmployeeUploadInfo[] = [];
  showPendingError: boolean = false;
  counter: number = 0;
  reference: string = '';
  arrayBuffer: any;
  fileDetailData: any;
  axioms: any[] = []; 
  modeOfHeadCountDropdown = [
    { option: 'Manpower' },
    { option: 'Service Provider' }
  ];
  headCountClassDropdown = [
    { option: 'Third-Party' },
    { option: 'SubContract' }
  ];

  formMode: 'multiple' | 'single' = 'multiple';

  singleEmployee: any = {
    contractId: 0,
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    gender: '',
    labourRate: 0,
    age: 0,
    address: '',
    qualification: '',
    position: '',
    desciption: '',
    lastPlaceOfWork: '',
    nextOfKin: '',
    nextOfKinPhone: '',
    nextOfKinAddress: '',
    requestNumber: '',
    workLocation: '',
    axiom: '',
    startDate: '',
    endDate: '',
    headCountClassification: '',
    modeOfHeadCount: ''
  };

  canUploadEmployee: boolean = false;

  constructor(
    private fileUploadService: FileUploadService,
    private notification: NotificationService,
    private contractsService: ContractsService,
    private axiomService: AxiomsService
  ) {}

  ngOnInit(): void {
    this.LoadDropDowns();
  }

  async LoadDropDowns() {
    let resContracts = await this.contractsService.getContractsValidforEmpcreation().toPromise();
    this.Contracts = <ContractDto[]>resContracts.responseData;




    let resAxioms = await this.contractsService.getAxioms().toPromise();
    this.axioms = <any[]>resAxioms.responseData;
  }

  isAxiomRequired(): boolean {
  // Return true only if the reference does NOT start with 'A'
  return !this.reference.startsWith('A');
}


  async onContractChange(e: any) {
    // const id = this.contract.id;
    this.reference =  this.contract.reference
    if(this.reference.startsWith("M", 0)){
      this.id = this.contract.manPowerRequestId;
    }else if(this.reference.startsWith("N", 0)){
      this.id = this.contract.contractId;
    }else if (this.reference.startsWith("A", 0)){
      this.id = this.contract.adhocRequestId;
    } 
    // let isManpower = this.reference.startsWith("M", 0);
    
    
    this.isAxiomRequired();

   this.canUploadEmployee = this.contract.activeNumberOfEmployees < this.contract.noOfStaff;


    let resContracts = await this.fileUploadService.GetByRequest(this.id,this.type).toPromise();
    this.uploadedfiles = <EmployeeUploadInfo[]>resContracts.responseData;


    this.showPendingError = this.uploadedfiles.some(i => i.uploadedFileStatus === 'New');
    this.fileDetailData = null;
  }

  onChange(event: any) {
    this.employeeFile = event.target.files[0];
    debugger
    if (this.employeeFile && this.employeeFile.name.endsWith('.xlsx')) {
      const fileReader = new FileReader();
      fileReader.readAsArrayBuffer(this.employeeFile);
      fileReader.onload = () => {
        this.arrayBuffer = fileReader.result;
        const data = new Uint8Array(this.arrayBuffer);
        const arr = Array.from(data).map(byte => String.fromCharCode(byte));
        const workbook = XLSX.read(arr.join(''), { type: 'binary' });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        this.fileDetailData = XLSX.utils.sheet_to_json(worksheet, { raw: true });
        this.counter = this.fileDetailData.length;
        this.uploadDisabled = false;
      };
    } else {
      this.uploadDisabled = true;
      this.fileDetailData = null;
    }
  }

  onUpload() {
    debugger
    const reader = new FileReader();
    let base64String: string;

    reader.onload = (e: any) => {
      const binaryData = e.target.result;
      base64String = btoa(binaryData);

      const data = {
        stringContent: base64String,
        fileName: this.employeeFile.name.split('.')[0],
        filePath: this.employeeFile.name,
        contractId: this.contract.contractId,
        type: this.contract.type

      };

      const fileCount = this.fileDetailData.length;
      const numberActive = this.contract.numberofActiveEmployees;
      const numberAllowed = this.contract.noOfStaff;

      if ((fileCount + numberActive) > numberAllowed) {
        this.notification.sendMessage({
          message: 'Please ensure uploaded file is within approved number of staff',
          type: NotificationType.error
        });
        return;
      }

      this.fileUploadService.upload(data).subscribe({
        next: (data) => {
          if (data.responseCode === "00") {
            this.notification.sendMessage({ message: data.message, type: NotificationType.success });
          } else {
            this.notification.sendMessage({ message: data.message, type: NotificationType.error });
          }
          location.reload();
        },
        error: (error: any) => {
          console.error(error.error);
          this.notification.sendMessage({ message: error.error.message, type: NotificationType.error });
        }
      });
    };

    reader.readAsBinaryString(this.employeeFile);
  }

  onCreateSingleEmployee(form: NgForm) {
    if (!this.contract) {
      this.notification.sendMessage({
        message: 'Please select a contract before submitting.',
        type: NotificationType.error
      });
      return;
    }

    if(form.invalid){
      this.notification.sendMessage({
        message: 'Please fill all required fields',
        type: NotificationType.info
      })
      return;
    }
    this.singleEmployee.requestNumber = this.contract.reference;
    this.singleEmployee.contractId = this.id;
    const payload = {
      ...this.singleEmployee,
      // contractId: this.contract.id,
      requestNumber: this.contract.reference
    };

    console.log('this is the payload ', payload);

    this.fileUploadService.createSingleEmployee(payload).subscribe({
      next: (res: any) => {
        this.notification.sendMessage({
          message: 'Employee created successfully!',
          type: NotificationType.success
        });
        this.resetSingleEmployeeForm();
      },
      error: (err: any) => {
        console.error(err);
        this.notification.sendMessage({
          message: 'Failed to create employee',
          type: NotificationType.error
        });
      }
    });
  }

  resetSingleEmployeeForm() {
    this.singleEmployee = {
      contractId: 0,
      otherNames: '',
      surname: '',
      email: '',
      phoneNumber: '',
      gender: '',
      labourRate: 0,
      dateOfBirth: '',
      address: '',
      qualification: '',
      position: '',
      desciption: '',
      lastPlaceOfWork: '',
      nextOfKin: '',
      nextOfKinPhone: '',
      nextOfKinAddress: '',
      requestNumber: '',
      workLocation: '',
      axiom: '',
      startDate: '',
      endDate: '',
      headCountClassification: '',
      modeOfHeadCount: ''
    };
  }
}
